<ng-template [ngIf]="indicador">
    <span 
        [class]="indicador | customerShareIndicadorBadge"
        [ngStyle]="{'fontSize': fontSize, 'padding': padding, 'width': width}">
        {{indicador | customerShareIndicador}}

        <span *ngIf="perc != null && perc !== undefined">
            ({{perc | decimalFormat: percMinIntegerDigits:percMinFractionDigits:percMaxFractionDigits}}%)
        </span>
    </span>
</ng-template>